// bootstrap.js

"use strict";

import angular from "angular";
import { EMPLEADOS_SWENO_ENERGIA } from "../app";
import "../assets/js/gtm.js";
import "../assets/js/analytics.js";

angular.bootstrap(document, [EMPLEADOS_SWENO_ENERGIA], {
  strictDi: true
});
